export const TABLE_EMPTY_MESSAGE = 'No items to display.';

export const COLUMN_ID_ACKNOWLEDGED_AT = 'acknowledgedAt';
export const COLUMN_ID_ACKNOWLEDGED_BY = 'acknowledgedBy';
export const COLUMN_ID_ACTION = 'action';
export const COLUMN_ID_ACTIVE_FOR = 'activeFor';
export const COLUMN_ID_ALARM_SP = 'alarmSetpoint';
export const COLUMN_ID_CURRENT = 'current';
export const COLUMN_ID_DATE = 'date';
export const COLUMN_ID_DEVICE_NAME = 'deviceName';
export const COLUMN_ID_DEVICE_TYPE = 'deviceType';
export const COLUMN_ID_ISSUE = 'issue';
export const COLUMN_ID_RESOLVED_AT = 'resolvedAt';
export const COLUMN_ID_SEVERITY = 'severity';
export const COLUMN_ID_STATUS = 'status';

export const STATUS_ACTIVE = 'Active';
export const STATUS_INACTIVE = 'Inactive';
